"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationOpportunityStatus = void 0;
exports.instanceOfOrientationOpportunityStatus = instanceOfOrientationOpportunityStatus;
exports.OrientationOpportunityStatusFromJSON = OrientationOpportunityStatusFromJSON;
exports.OrientationOpportunityStatusFromJSONTyped = OrientationOpportunityStatusFromJSONTyped;
exports.OrientationOpportunityStatusToJSON = OrientationOpportunityStatusToJSON;
exports.OrientationOpportunityStatusToJSONTyped = OrientationOpportunityStatusToJSONTyped;
/**
 *
 * @export
 */
exports.OrientationOpportunityStatus = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED',
    Canceled: 'CANCELED'
};
function instanceOfOrientationOpportunityStatus(value) {
    for (const key in exports.OrientationOpportunityStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationOpportunityStatus, key)) {
            if (exports.OrientationOpportunityStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationOpportunityStatusFromJSON(json) {
    return OrientationOpportunityStatusFromJSONTyped(json, false);
}
function OrientationOpportunityStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationOpportunityStatusToJSON(value) {
    return value;
}
function OrientationOpportunityStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationOpportunityStatus.js.map